import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useMarkAsPresent = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: { id: string }) =>
      httpService.panel.panelAbsencesMarkAsPresentCreate(data.id),
    onSuccess,
    onError
  })

export default useMarkAsPresent
